import { AuthenticatedRouter } from './AuthenticatedRouter';
import { authClient } from './lib/authClient';
import { trpc } from './lib/trpc';
import { Mantine } from './Mantine';
import { UnauthenticatedRouter } from './UnauthenticatedRouter';
import { QueryClient } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { useEffect, useMemo } from 'react';
import superjson from 'superjson';
import { useLocation, useSearch } from 'wouter';

// if (import.meta.env.PROD) {
//   LogRocket.init('s6dct5/clew', {
//     dom: {
//       inputSanitizer: true,
//       textSanitizer: true,
//     },
//   });
//   setupLogRocketReact(LogRocket);
// }
// withReactQueryProvider(
// withCustomLogic(() => {

const App = () => {
  const queryClient = useMemo(() => new QueryClient(), []);
  const trpcClient = useMemo(
    () =>
      trpc.createClient({
        links: [
          httpBatchLink({
            fetch(url, options) {
              return fetch(url, {
                ...options,
                credentials: 'include',
              });
            },
            transformer: superjson,
            url: '/api',
          }),
        ],
      }),
    [],
  );

  const [, navigate] = useLocation();

  const token = new URLSearchParams(useSearch()).get('token');

  useEffect(() => {
    if (token) {
      (async () => {
        await authClient.magicLink.verify({
          query: {
            token,
          },
        });
        const url = new URL(document.location.href);
        url.searchParams.delete('token');
        document.location.href = url.href;
      })();
    }
  }, [navigate, token]);

  const { data: session, isPending } = authClient.useSession();

  if (token || isPending) {
    return null;
  }

  const content =
    session?.session && session.user ? (
      <Mantine>
        <AuthenticatedRouter />
      </Mantine>
    ) : (
      <Mantine forceColorScheme="light">
        <UnauthenticatedRouter />
      </Mantine>
    );

  return (
    <trpc.Provider
      client={trpcClient}
      queryClient={queryClient}
    >
      {content}
    </trpc.Provider>
  );
};

export default App;
